export default __webpack_public_path__ + "static/media/bg-flow-1.ea67be86.png";